import * as moment from 'moment';
export var DateUtils;
(function (DateUtils) {
    const niceFormat = 'dddd, Do MMMM YYYY';
    DateUtils.formatDate = (date) => {
        const momentDate = moment(date);
        return momentDate.format(niceFormat);
    };
})(DateUtils || (DateUtils = {}));
